/**
 * HTTP request timeout constants for the Soteria UI
 *
 * All HTTP clients should reference these constants rather than
 * hardcoding timeout values, so timeouts can be adjusted in one place.
 */

/**
 * Default HTTP request timeout in milliseconds (30 seconds).
 * Applied automatically by the Apollo timeout link to all GraphQL operations.
 */
export const DEFAULT_HTTP_TIMEOUT_MS = 30000;

/**
 * Extended GraphQL operation timeout in milliseconds (120 seconds).
 * Used for slow operations (audit, classification, moderation, prompt generation)
 * via `context: { timeout: EXTENDED_GRAPHQL_TIMEOUT_MS }` in useQuery/useMutation.
 */
export const EXTENDED_GRAPHQL_TIMEOUT_MS = 120000;

/**
 * Extended timeout for media operations in milliseconds (60 seconds).
 * Media uploads/downloads may take longer than standard HTTP requests.
 * Used by MediaService as the default when no explicit timeout is provided.
 */
export const EXTENDED_MEDIA_TIMEOUT_MS = 60000;
